export enum CustomFormatOption {
  Number = "Number",
  Percentage = "Percentage",
  Currency = "Currency",
}
